import {
  Alert,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Spin,
  Switch,
  Tabs,
  notification,
} from 'antd';
import { FormInstance, useForm } from 'antd/lib/form/Form';
import {
  ProcTaskInit,
  getTaskCheckEntity,
  getTaskConseqEntity,
  getTaskStepEntity,
} from 'services/workflow';
import React, { useContext, useEffect, useState } from 'react';
import { downloadBlobFile, prepareObjectForApiCall } from 'utils/utils2';
import { isArray, isNil, noop } from 'lodash';

import { API_URLS } from 'utils/config';
import ActivityModal from 'pages/workflow/workflowSFS/TabTPActivity';
import AddresseModal from './TabTpAddress';
import { AuthContext } from 'components/Auth/Auth';
import Button from 'components/Button';
import ButtonLink from 'components/theme_components/ButtonLink';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import DF from 'DisplayFramework';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Notifications from 'components/theme_components/Notifications';
import TabActivatePermeability from './TabsActivity/TabActivatePermiability';
import TabBanKAccount from './TabTPBankAccount';
import TabDeleteActivity from './TabsActivity/TabDeleteActivity';
import TabDeleteSiloInter from './TabsSilo/TabDeleteSiloInter';
import TabEvAuthorization from '../tabEvTPAuthorization';
import TabForceAcceptance from 'pages/ProposalV3/Components/Modals/TabForceAcceptance';
import TabInterBrand from './TabsSilo/TabInterBrand';
import TabIntraBrand from './TabsSilo/TabIntraBrand';
import TabOverActivity from './TabsActivity/TabOverActivity';
import TabUpdateAuthAmount from './TabsActivity/TabUpdateAuthAmount';
import TabUpdateCreditControl from './TabsActivity/TabUpdateCreditControl';
import TabUpdateMPEAAmount from './TabsActivity/TabUpdateMPEAAmount';
import TabUpdateStatusAuth from './TabsActivity/TabUpdateStatusAuth';
import Title from 'components/Title';
import { customDataPrepareForApiCallSFS } from 'utils/utilsSFS';
import { generateMassiveDocToPrintAndEmail } from 'services/printingService';
import { getProductList } from 'services/parametersService';
import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import { parseQueryParams } from 'utils/parseQueryParams';
import { request } from 'utils/request';
import { useQuery } from 'react-query';
import PaymentModal from 'pages/ProposalV3/Components/Modals/PaymentModal';
import TabAcceptPayment from 'pages/ProposalV3/Components/Modals/TabAcceptPayment';
import ConversionModal from 'pages/ProposalV3/Components/Modals/ConversionModal';
import TabAcceptConversion from 'pages/ProposalV3/Components/Modals/TabAcceptConversion';

const PRINTING_URL = API_URLS.PRINTING;

interface Product {
  prcode: string;
  [key: string]: any;
}

const useGetProductList = () => {
  return useQuery('getProductList', () =>
    getProductList().then((res) => res.list || [])
  );
};
const { TabPane } = Tabs;

const funcodeToComponent: any = {
  tabEvTPAuthorization: ActivityModal,
  tabTPChangeAddress: AddresseModal,
  tabTPChangeBankAcc: TabBanKAccount,
  tabUpdateAuthamount: TabUpdateAuthAmount,
  tabUpdateMPEAamount: TabUpdateMPEAAmount,
  tabUpdateAuthStatus: TabUpdateStatusAuth,
  tabUpdateTPOveractivity: TabOverActivity,
  tabActivatePermeability: TabActivatePermeability,
  tabDeleteTPAuthorization: TabDeleteActivity,
  tabUpdateCreditControl: TabUpdateCreditControl,
  tabCreateSiloInter: TabInterBrand,
  tabUpdateSiloInter: TabInterBrand,
  tabUpdateSiloIntra: TabIntraBrand,
  tabDeleteSiloInter: TabDeleteSiloInter,
  tabForceAcceptance: TabForceAcceptance,
  tabschedulepayment:PaymentModal,
  tabSfsAcceptpay:TabAcceptPayment,
  tabAcceptconversion:TabAcceptConversion,
  tabconvertcontract:ConversionModal
  // tabUpdateInterBrandSilo: IntermarqueModal,
  // tabUpdateIntraBrandSilo: IntramarqueModal,
};

const getUrl = (
  jobid: number | string,
  filetype: string,
  entity?: string,
  mode?: string,
  indexfile?: number
): string => {
  if (mode === 'PRINTING') {
    return `${API_URLS.PRINTING}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'PAYMENT' || mode === 'PAYMENT') {
    return `${API_URLS.PAYMENT}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'CINVOICE') {
    return `${API_URLS.CLIENT_INVOICE}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'SINVOICE') {
    return `${API_URLS.SUPPLIER_INVOICE}/api/supplier/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'COLLECTION') {
    return `${API_URLS.COLLECTION}/api/collection/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'CONFIG') {
    return `${API_URLS.CONFIGURATION_SERVICE}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else if (entity === 'ASSETCONFIG') {
    return `${API_URLS.ASSETS_CONFIG}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
  } else {
    if (indexfile) {
      return `${API_URLS.ACCOUNTING}/api/job/download?jobid=${jobid}&filetype=${filetype}&indexfile=${indexfile}`;
    } else {
      return `${API_URLS.ACCOUNTING}/api/job/download?jobid=${jobid}&filetype=${filetype}`;
    }
  }
};

export type TaskModalProps = {
  tptype?: string;
  countcode?: string;
  formTP?: FormInstance;
  mgid?: number;
  entityId: number;
  entity: string;
  entityName: string;
  entityReference?: string;
  subentity?: string;
  subentityid?: number;
  onCancel: () => void;
  task: ProcTaskInit;
  visible: boolean;
  onSuccess?: any;
  random: number;
  tpid?: number;
  data?: any;
  dataInput?: any;
  dataList?: any;
  action?: string;
  funcode?: string;
  entityList?: Array<{ entityId: number }>;
  status?: string;
  statusdate?: string;
  requestedamount?: number;
  currcode?: string;
  parcode?: string;
  parvalue?: string;
  parvalueparent?: string;
  clientName?: string;
  ctrid?: number;
  wizardsteps?: boolean;
  title?: string;
  titlewithName?: any;
  refetch: () => void;
  width: number;
  prcodeProps?: string;
  genericActions?: boolean;
  message?:string;
  brand?:string;
};

const TaskModal = ({
  refetch,
  data,
  tptype,
  countcode,
  formTP,
  mgid,
  entity,
  entityId,
  entityName,
  entityReference,
  subentity,
  subentityid,
  tpid,
  onCancel,
  task,
  visible,
  dataInput,
  onSuccess = noop,
  random,
  entityList,
  status,
  statusdate,
  requestedamount,
  currcode,
  parcode,
  parvalue,
  parvalueparent,
  clientName,
  ctrid,
  wizardsteps,
  title,
  titlewithName,
  width,
  dataList,
  prcodeProps,
  genericActions,
  message,
  brand,
}: TaskModalProps) => {
  const [form] = useForm();
  const { isInspect } = useContext(AuthContext);

  const [successful, setSuccessful] = useState<boolean>(false);
  const [isFinish, setIsFinish] = useState<boolean>(false);
  const [modalVisible, setModalVisible] = useState(genericActions ? true : false);

  const [additionalAttributeList, setadditionalAttributeList] = useState<any>();
  const [load, setload] = useState(false);
  const [activeKey, setActiveKey] = useState<string>('check');
  const params = {
    entity: entity,
    entityid: entityId,
    taskid: task.taskid ?? 0,
    subentity: task.subentity,
    subentityid: task.subentityid,
  };

  const [spinningConseq, setSpinningConseq] = useState(false);
const handleOk = () => {
  form
    .validateFields()
    .then((values) => {
      const [url, paramsString] = task.serviceurl?.split('?') ?? ['', ''];
      setload(true);

   
      const tpBankAccountProductList = Object.entries(values.priority || {})
        .filter(([prcode]) => values[prcode]) // case cochée
        .map(([prcode, priority]) => ({
          tpid: values.entityId ?? entityId ?? tpid, // Use entityId from props if values.entityId is not available
          tpbkid: values.subentityid ?? subentityid ?? values.tpbkid, // Use subentityid from props if not in values
          prcode,
           priority: parseInt(priority as string || '1', 10),

        }));

     
      const cleanedValues = { ...values };
      ['PR', 'VD', 'VN', 'VO'].forEach((key) => {
        delete cleanedValues[key];
      });
      delete cleanedValues.priority;

     
      const payload = {
        ...cleanedValues,
        tpBankAccountProductList,
        bktype: cleanedValues.bktype || 'INOUT', // Default to 'INOUT' if null/undefined
        currcode: cleanedValues.currcode || 'EUR', // Default to 'EUR' if null/undefined
        countcode: cleanedValues.countcode || 'FR', // Default to 'FR' if null/undefined
        bkholder:  cleanedValues.bkholder, // Use tpbankname as bkholde
      };

     
      request
        .post(`${API_URLS.WORKFLOW}/api/${url}`, {
          ...parseQueryParams(paramsString),
          ...payload,
          entityId,
          entity,
          taskid: task?.taskid,
          subentity: task?.subentity,
          subentityid: task?.subentityid,
          objectreference: entityReference,
          ...prepareObjectForApiCall(payload),
          ...customDataPrepareForApiCallSFS(payload, entity, entityId, entityReference, form),
          entityAddAttributList: additionalAttributeList ?? [],
        })
        .then((res) => {
          onCancel();
          visible = false;
          if (res.success) {
            Notifications({
              status: 'success',
              message: res.message,
              description: res.description,
              duration: 6,
              placement: 'top',
            });
            setIsFinish(true);
            onSuccess();
            setload(false);
            onCancel();
            refetch && refetch();
          } else {
            setload(false);
            return Promise.reject(res);
          }
        })
        .catch((res) => {
          try {
            let errormsg: any;
            if (res.message && !isNil(res.message) && res.message !== '') {
              let listError = JSON.parse(res.message);
              if (isArray(listError)) {
                errormsg = React.createElement(
                  'table',
                  { className: 'styled-table' },
                  null,
                  React.createElement(
                    'thead',
                    null,
                    React.createElement(
                      'tr',
                      { className: 'active-row' },
                      React.createElement('th', null, 'Code'),
                      React.createElement('th', null, 'Message')
                    )
                  ),
                  listError.map((error: any) => {
                    return React.createElement(
                      'tr',
                      { className: 'active-row' },
                      React.createElement(
                        'td',
                        { style: { fontWeight: '700' } },
                        error.ccode
                      ),
                      React.createElement('td', null, error.message)
                    );
                  })
                );

                notification.error({
                  description: errormsg,
                  message: React.createElement(
                    'span',
                    { style: { fontWeight: '700', color: '#660000' } },
                    'Functional Controls'
                  ),
                  className: 'error417',
                  style: {
                    width: 400,
                    padding: '9px 12px 1px 12px',
                    marginLeft: 0,
                  },
                });
              } else {
                errormsg = listError;
                notification.error({
                  message: errormsg,
                });
              }
            }
            return Promise.reject(res);
          } catch (Exception) {
            notification.error({ message: res.message });
          }
          setload(false);
        });
    })
    .catch((e) => {
      onFinishFailed(e);
    });
};

  //here
  // const {
  //   data: checks,
  //   isLoading: checkLoading,
  //   refetch: refetchChecks,
  // } = useQuery(
  //   ['getTaskCheckEntity', params],
  //   () =>
  //     getTaskCheckEntity(params)
  //       .then((res) => {
  //         setload(false);
  //         return res.list || [];
  //       })
  //       .catch((err) => {
  //         setload(false);
  //         return [];
  //       }),
  //   {
  //     enabled: visible,
  //     /*refetchInterval: 3000,
  //     refetchIntervalInBackground: true,
  //     staleTime: Infinity,*/
  //   }
  // );

  const { data: steps } = useQuery(
    ['getTaskStepEntity', params],
    () => getTaskStepEntity(params).then((res) => res.list || [])
    // { enabled: visible }
  );

  // const hasFailedChecks =
  //   checks?.find((check) => check.controlCheck === false) !== undefined;

  // const {
  //   data: consequences,
  //   refetch: refetchConsequences,
  //   isFetching,
  //   isRefetching,
  // } = useQuery(
  //   ['getTaskConseqEntity', params],
  //   () => getTaskConseqEntity(params).then((res) => res.list ?? undefined),
  //   {
  //     enabled: !hasFailedChecks && visible,
  //     refetchInterval: 3000,
  //     refetchIntervalInBackground: true,
  //     staleTime: Infinity,
  //   }
  // );

  const firstStep = steps && steps.length > 0 && steps[0];

  const ExtraStepComponent = firstStep && funcodeToComponent[firstStep.funcode];

  useEffect(() => {
    // if (hasFailedChecks) {
    //   setActiveKey('check');
    // } else if (firstStep) {
    // } else {
    //   setActiveKey('consequences');
    // }

    setActiveKey('extra-step');
  }, [firstStep]);

  const generateMassiveDocToPrint = () => {
    let listToGenerateMassiveDoc: any[] = [];

    const printAllInOne = form.getFieldValue('flagEditAllInOne') ?? false;
    setSpinningConseq(true);

    // consequences?.forEach((item) => {
    //   if (item.conseqtype === 'PRINT') {
    //     listToGenerateMassiveDoc.push({
    //       doccode: item.conseqcode,
    //       conseqid: item.conseqid,
    //       notifid: item.notifid,
    //       entityid: item.entityid,
    //       entity: item.entity,
    //       subentity: item.subentity ?? '',
    //       subentityid: item.subentityid ?? 0,
    //       flagEmail: false,
    //       emailTo: item.emailtotarget,
    //       emailCc: item.emailcctarget,
    //       printid: item.printid,
    //     });
    //   }
    // });

    if (listToGenerateMassiveDoc.length > 0) {
      generateMassiveDocToPrintAndEmail({
        docToPrintAndEmailResponses: listToGenerateMassiveDoc,
        execMode: 'DB',
        printAllInOne: printAllInOne,
        kafkaEnabled: 'false',
      })
        .then(async (res: any) => {
          if (printAllInOne === true) {
            const globalDocObject = res.list[res.list.length - 1];
            setSpinningConseq(true);

            await downloadBlobFile(
              res.list[res.list.length - 1].outputfile,
              getUrl(globalDocObject.jobid, 'OUTPUT', entity, 'PRINTING', 0)
            )
              .then(() => {
                setSpinningConseq(false);
              })
              .catch(() => {
                setSpinningConseq(false);
              });
          } else {
            await getTaskConseqEntity(params)
              .then(async (res) => {
                await Promise.all(
                  res.list.map((item) => {
                    setSpinningConseq(true);
                    if (item.conseqtype === 'PRINT') {
                      return downloadBlobFile(
                        `${item.conseqcode}-${item.entity}-${item.entityid}-${item.conseqid}.pdf`,
                        `${PRINTING_URL}/api/print/download?printid=${item.printid}`
                      );
                    }
                  })
                )
                  .then(() => {
                    setSpinningConseq(false);
                  })
                  .catch(() => {
                    setSpinningConseq(false);
                  });
              })
              .catch((err) => {
                setSpinningConseq(false);
              });
          }
        })
        .catch(() => {
          setSpinningConseq(false);
        });
    } else {
      setSpinningConseq(false);
    }
  };
  return (
    <DF.Provider pagcode="taskmodal" entity={entity} entityid={entityId}>
      <Form form={form ?? formTP} preserve={false} layout="vertical">
        <Modal
          className="modal-sfs"
          destroyOnClose
          // afterClose={() => {
          //   setSuccessful(false);
          // }}
          open={visible}
          // onCancel={() => {
          //   setSuccessful(false);
          //   onCancel();
          // }}
          width={width ?? 800}
          onCancel={() => {
            onCancel();
          }}
          title={
            title && titlewithName ? (
              <p
                style={{
                  fontSize: '24px',
                  fontWeight: 500,
                }}
              >
                <GetLabel label={title ?? ''} /> {titlewithName ?? ''}{' '}
              </p>
            ) : title ? (
              <GetLabel
                style={{
                  fontSize: '24px',
                  fontWeight: 500,
                }}
                label={title ?? ''}
              />
            ) : (
             ""
            )
          }
          footer={
            wizardsteps ? null : (
              <div style={{ background: 'wihte' }}>
                <Row justify="end">
                  <ButtonLink
                    key="cancel"
                    comcode="cancel"
                    onClick={() => !isInspect && onCancel()}
                  />

                  <ButtonLink
                    key="ok"
                    comcode="ok"
                    type="primary"
                    disabled={isFinish || successful}
                    className="ml-8"
                    loading={load}
                    onClick={() => {
                      if (!isInspect) {
                        form.submit();
                        handleOk();
                      }
                    }}
                  />
                </Row>
              </div>
            )
          }
        >
          {ExtraStepComponent && (
            <ExtraStepComponent
              clientName={clientName}
              data={data}
              dataInput={dataInput}
              objectid={entityId}
              tpid={tpid}
              ctrid={ctrid}
              object={entity}
              subentity={subentity}
              subentityid={subentityid}
              form={form}
              mgid={mgid}
              formTP={formTP}
              tptype={tptype}
              countcode={countcode}
              entityReference={entityReference}
              entityList={entityList}
              status={status}
              statusdate={statusdate}
              requestedamount={requestedamount}
              currcode={currcode}
              entityName={entityName}
              setSuccessful={setSuccessful}
              parcode={parcode}
              parvalue={parvalue}
              parvalueparent={parvalueparent}
              setadditionalAttributeList={setadditionalAttributeList}
              onDone={handleOk}
              onCancel={() => {
                onCancel();
                visible = false;
              }}
              loading={load}
              dataList={dataList}
              prcodeProps={prcodeProps}
              funcode={firstStep?.funcode}
              brand={brand}
            />
          )}
          {/* <Tabs>
            <TabPane tab="Task Details" key="1">
             
            </TabPane>
            <TabPane tab={<GetLabel label="Check" />} key="2"></TabPane>
            <TabPane tab={<GetLabel label="Consequences" />} key="3"></TabPane>
          </Tabs> */}
        </Modal>
      </Form>
    </DF.Provider>
  );
};

export default TaskModal;
